// extracted by mini-css-extract-plugin
module.exports = {"container":"Desktop_container__18FU3","content":"Desktop_content__1Tl-I"};